import type { FC } from 'react'
import { colors } from 'settings/colors'

export const MaintenanceBanner: FC<{ message: string }> = (props) => {
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 10,
        padding: 'calc(env(safe-area-inset-top) + 10px) 12px 10px',
        backgroundColor: colors.red150,
      }}
    >
      <div>{props.message}</div>
    </div>
  )
}
